import httpCommon from "./http-common";

// Get all transactions for a business
const getAllTransactions = (businessId: number, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/accountTransactions/${businessId}?skip=${skip}&limit=${limit}`);
};

// Get transactions by account ID
const getTransactionsByAccountId = (businessId: number, accountId: string, skip = 0, limit = 0) => {
  return httpCommon.get(`/v1/get/accountTransactions/${businessId}/${accountId}?skip=${skip}&limit=${limit}`);
};

// Get transaction by ID
const getTransactionById = (publicId: string) => {
  return httpCommon.get(`/v1/get/accountTransaction/${publicId}`);
};

// Create transaction
const createTransaction = (data: any, businessId: number) => {
  return httpCommon.post(`/v1/add/accountTransaction/${businessId}`, data);
};

// Update transaction
const updateTransaction = (publicId: string, data: any) => {
  return httpCommon.put(`/v1/update/accountTransaction/${publicId}`, data);
};

// Delete transaction
const deleteTransaction = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/accountTransaction/${publicId}`);
};

// Get transactions by date range
const getTransactionsByDateRange = (
  businessId: number, 
  startYear: number, 
  startMonth: number, 
  startDay: number, 
  endYear: number, 
  endMonth: number, 
  endDay: number,
  accountId?: string
) => {
  const accountParam = accountId ? `&accountId=${accountId}` : '';
  return httpCommon.get(
    `/v1/getDataUsingDateRange/accountTransactions/${businessId}?startYear=${startYear}&startMonth=${startMonth}&startDay=${startDay}&endYear=${endYear}&endMonth=${endMonth}&endDay=${endDay}${accountParam}`
  );
};

// Get transactions by reference type and ID
const getTransactionsByReference = (businessId: number, referenceType: string, referenceId: string) => {
  return httpCommon.get(`/v1/get/accountTransactions/reference/${businessId}/${referenceType}/${referenceId}`);
};

const TransactionsService = {
  getAllTransactions,
  getTransactionsByAccountId,
  getTransactionById,
  createTransaction,
  updateTransaction,
  deleteTransaction,
  getTransactionsByDateRange,
  getTransactionsByReference,
};

export default TransactionsService;
